export default "__VITE_ASSET__67a083ad__"